module.exports = __webpack_public_path__ + "img/yz_2@2x.0c9d0df2.png";